import { gql } from "urql";

// Queries

// Get paginated list of image threads (with latest iteration preview)

export const imageThreadPageQuery = gql`
    query ImageThreadPageQuery($page:Int!, $filter: ImageThreadPageFilter!) {
        imageThreadPage(page:$page, filter:$filter) {
            items {
                id
                created
                user { id }
                iterations(last: 1) {
                    edges {
                        node {
                            id
                            userText
                            size
                            quality
                            file { id src fileName }
                        }
                    }
                }
            }
            maxPage
        }
    }
`;

export type * from "./__generated__/image-thread-page-query";

// Get single image thread with iterations

export const imageThreadQuery = gql`
    query ImageThreadQuery($id:Int!) {
        imageThread(id:$id) {
            id
            created
            updated
            iterations(first: 100) {
                edges {
                    node {
                        id
                        userText
                        size
                        quality
                        file { id src fileName }
                    }
                }
            }
        }
    }
`;

export type * from "./__generated__/image-thread-query";

// Mutations

// Create a new image thread

export const imageThreadCreateMutation = gql`
    mutation ImageThreadCreateMutation($initialText:String!, $size:String, $quality:String) {
        imageThreadCreate(initialText:$initialText, size:$size, quality:$quality) {
            id
        }
    }
`;

export type * from "./__generated__/image-thread-create-mutation";

// Create a new iteration for an image thread

export const imageThreadIterateMutation = gql`
    mutation ImageThreadIterateMutation($imageThreadId:Int!, $text:String!, $size:String, $quality:String) {
        imageThreadIterate(imageThreadId:$imageThreadId, text:$text, size:$size, quality:$quality) {
            id
            userText
            size
            quality
            file { id src fileName }
        }
    }
`;

export type * from "./__generated__/image-thread-iterate-mutation";

// Delete an image thread

export const imageThreadDeleteMutation = gql`
    mutation ImageThreadDeleteMutation($imageThreadId:Int!) {
        imageThreadDelete(imageThreadId:$imageThreadId) { id }
    }
`;

export type * from "./__generated__/image-thread-delete-mutation";
